export default __webpack_public_path__ + "static/media/ART1.fcd84a76.jpg";